import { CircularProgressbar, buildStyles  } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

import styles from './ProgressBar.module.css'  

const ProgressBar = (props) => {
    const percentage = props.value
    return (
        <div>
            <CircularProgressbar 
                value={percentage} 
                text={`${percentage}%`} 
                styles={buildStyles({
                    pathTransitionDuration: 1.5,
                })
                }
            />
        </div>
    )
}

export default ProgressBar